import { useState } from 'react';
import AddIcon from '../../Images/add-circle.png';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

const TableWithPagination = ({
	data,
	columns,

	allLibraries,
	onLibraryChange,
}) => {
	const pageSizeOptions = [5, 10, 20, 50];
	const [pageSize, setPageSize] = useState(pageSizeOptions[1]);
	const [currentPage, setCurrentPage] = useState(1);

	const totalItems = data.length;
	const totalPages = Math.ceil(totalItems / pageSize);

	const startIndex = (currentPage - 1) * pageSize;
	const paginatedData = data.slice(startIndex, startIndex + pageSize);

	const navigate = useNavigate();

	const handlePrev = () => setCurrentPage((p) => Math.max(p - 1, 1));
	const handleNext = () => setCurrentPage((p) => Math.min(p + 1, totalPages));

	const handlePageSizeChange = (e) => {
		setPageSize(Number(e.target.value));
		setCurrentPage(1);
	};

	return (
		<div className='w-full bg-white p-2 shadow-md rounded-xl'>
			<div className='header flex justify-end pt-4'>
				<button
					className='px-4 py-2 bg-[#00BC92] text-white rounded-[6px] flex items-center gap-2'
					onClick={() => navigate('/news/0')}
				>
					<div>
						<img src={AddIcon} alt='Add News' />
					</div>
					<div>Add News</div>
				</button>
			</div>

			<div className='flex flex-col justify-center items-center lg:justify-between lg:flex-row mb-4 lg:p-4'>
				<div className='pb-4'>
					<label className='mr-2'>Items per page:</label>
					<select
						className='border rounded px-2 py-1'
						value={pageSize}
						onChange={handlePageSizeChange}
					>
						{pageSizeOptions.map((size) => (
							<option key={size} value={size}>
								{size}
							</option>
						))}
					</select>
				</div>
				<div className='flex items-center'>
					<button
						onClick={handlePrev}
						disabled={currentPage === 1}
						className='px-3 py-1 bg-gray-200 rounded-l disabled:opacity-50'
					>
						<span aria-hidden='true'>&lsaquo;</span>
						<span className='sr-only'>Previous</span>
					</button>

					<span className='px-4 text-sm'>
						Page {currentPage} of {totalPages}
					</span>
					<button
						onClick={handleNext}
						disabled={currentPage === totalPages}
						className='px-3 py-1 bg-gray-200 rounded-r disabled:opacity-50'
					>
						<span aria-hidden='true'>&rsaquo;</span>
						<span className='sr-only'>Next</span>
					</button>
				</div>
			</div>

			<div className='flex flex-col lg:px-4'>
				<div className='mt-4'>
					<Select
						options={allLibraries}
						placeholder='Filter by institution'
						className='basic-multi-select'
						onChange={(selected) => onLibraryChange(selected.value)}
					/>
				</div>
			</div>
			{/* table */}
			<div className='overflow-auto border-none  rounded lg:p-4'>
				<table className='min-w-full bg-white border'>
					<thead>
						<tr>
							{columns.map((col) => (
								<th
									key={col.header}
									className='p-4 border-b text-left text-sm font-medium text-gray-700 bg-[#fafbfb]'
								>
									{col.header}
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{paginatedData.map((row, idx) => (
							<tr key={startIndex + idx} className='hover:bg-gray-50'>
								{columns.map((col) => (
									<td
										key={col.header}
										className='px-4 py-4 border-b text-sm text-gray-600'
									>
										{col.cell ? col.cell(row) : row[col.accessor]}
									</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
				{totalItems === 0 && (
					<div className='pt-4 font-medium text-center w-full'>No records</div>
				)}
			</div>
		</div>
	);
};

export default TableWithPagination;
